import { CirclePlus, SearchX } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/button'
import { NewCardProperties } from '@/components/property/newCard-property'
import { Skeleton } from '@/components/skeleton'
import { TitleSeparator } from '@/components/title-separator'
import { useAuth } from '@/contexts'
import { Property } from '@/models/property'

interface NewProjectsProps {
  properties: Property[]
  filter: string
  biome: string
  propertiesTotal: number
  loadMoreProjects(): void
  loading: boolean
}

export function NewProjects({
  properties,
  biome,
  filter,
  propertiesTotal,
  loadMoreProjects,
  loading,
}: NewProjectsProps) {
  const navigate = useNavigate()
  const { signed } = useAuth()

  return (
    <div className="flex flex-col">
      <TitleSeparator title="Novos projetos" />
      {(filter !== '' || biome !== '') && properties.length <= 0 && (
        <div className="mt-6 space-y-5 2xl:mt-10">
          <SearchX className="mx-auto size-16 text-zinc-600" />
          <h3 className="text-center text-2xl text-zinc-600">
            Nenhum projeto encontrado
          </h3>
        </div>
      )}

      <div className="mt-6 grid h-96 flex-1 grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
        {filter === '' && biome === '' && properties.length <= 0 && (
          <Skeleton quantity={4} className="h-96 w-full rounded-2xl" />
        )}
      </div>
      {properties && properties.length > 0 && (
        <NewCardProperties properties={properties} />
      )}
      <div className="mx-auto mt-5 flex items-center justify-center gap-5 2xl:mt-10 2xl:gap-6">
        <Button
          className="text-monochromatic-400 flex items-center gap-2 font-semibold uppercase disabled:border-none disabled:bg-transparent"
          variant="ghost"
          disabled={
            properties.length === propertiesTotal ||
            loading ||
            filter !== '' ||
            (biome !== '' && properties.length <= propertiesTotal)
          }
          onClick={loadMoreProjects}
        >
          <CirclePlus size={20} />
          Veja mais projetos
        </Button>

        {!signed && (
          <Button onClick={() => navigate('/register')} className="uppercase">
            Patrocine uma área
          </Button>
        )}
      </div>
    </div>
  )
}
